export default __webpack_public_path__ + "static/media/settings.12871b00.svg";